<form class="orderForm" #orderForm="ngForm">
  @if (order(); as order) {
    <div class="toolbar">
      <span>
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="backToOrderMaster()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <span class="buttonLabel">Back To Search</span>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span>
        @if (showProjectDefaultsButton()) {
          <button class="toolbarButton" matButton="text"
            [matMenuTriggerFor]="projectActionsMenu">
            <span>
              <span class="buttonLabel">Project Defaults</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #projectActionsMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="openProjectDefaultsScreen()">
            <mat-icon class="size-12">dashboard</mat-icon>
            <span class="buttonLabel">Project Level Information</span>
          </button>
        </mat-menu>
        @if (order.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="pricingMenu">
            <span>
              <span class="buttonLabel">Pricing</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #pricingMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="multiplier()">
            <mat-icon class="size-12">keyboard</mat-icon>
            <span class="buttonLabel">Multiplier</span>
          </button>
          @if (showFpaManagementButton()) {
            <button class="menuButton" mat-menu-item (click)="fpaManagement()">
              <mat-icon class="size-12">attach_money</mat-icon>
              <span class="buttonLabel">Request FPA</span>
            </button>
          }
          @if (showFpaCancelButton()) {
            <button class="menuButton" mat-menu-item (click)="cancelFpaReview()">
              <mat-icon class="size-12">cancel</mat-icon>
              <span class="buttonLabel">Cancel FPA Review</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
            <button class="menuButton" mat-menu-item
              (click)="viewEntityBreaks()">
              <mat-icon class="size-12">subject</mat-icon>
              <span class="buttonLabel">Order Breaks</span>
            </button>
          }
          @if (canUpdateExtendedWarranty()) {
            <button class="menuButton" mat-menu-item
              (click)="showExtendedWarrantyDialog()">
              <mat-icon class="size-12">verified</mat-icon>
              <span class="buttonLabel">Extended Warranty</span>
            </button>
          }
          @if (isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item (click)="openCostReport()">
              <mat-icon class="size-12">request_quote</mat-icon>
              <span class="buttonLabel">Cost Report</span>
            </button>
            <button class="menuButton" mat-menu-item (click)="openAutoCostReport()">
              <mat-icon class="size-12">auto_graph</mat-icon>
              <span class="buttonLabel">Auto-Cost Report</span>
            </button>
          }
        </mat-menu>
        @if (order.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="actionsMenu">
            <span>
              <span class="buttonLabel">Actions</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #actionsMenu="matMenu" [overlapTrigger]="false">
          @if (isBlanket() && (userHasRole('IECIT') || userHasRole('IECCustomerService'))) {
            <button class="menuButton"
              mat-menu-item (click)="generateRevision()">
              <mat-icon class="size-12">archive</mat-icon>
              <span class="buttonLabel">Generate Revision</span>
            </button>
          }
          <button class="menuButton" mat-menu-item (click)="cancel()">
            <mat-icon class="size-12">do_not_disturb</mat-icon>
            <span class="buttonLabel">Cancel</span>
          </button>
          @if (showIecRelease()) {
            <button class="menuButton" mat-menu-item (click)="releasePendingApproval()">
              <mat-icon class="size-12">send</mat-icon>
              <span class="buttonLabel">IEC Release</span>
            </button>
          }
          @if (canRelease()) {
            <button class="menuButton" mat-menu-item (click)="generateRelease()"
              [disabled]="mockupPending()" matTooltip="Mockup Pending Approval" [matTooltipDisabled]="!mockupPending()">
              <mat-icon class="size-12">create_new_folder</mat-icon>
              <span class="buttonLabel">Generate Release</span>
            </button>
          }
          @if (readyForScheduling()) {
            <button class="menuButton" mat-menu-item (click)="sendToScheduling()">
              <mat-icon class="size-12">insert_invitation</mat-icon>
              <span class="buttonLabel">Scheduling</span>
            </button>
          }
          @if (isAcknowledgmentReady()) {
            <button class="menuButton" mat-menu-item (click)="sendAcknowledgment()">
              <mat-icon class="size-12">mail</mat-icon>
              <span class="buttonLabel">Send Acknowledgment</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
            <button class="menuButton" mat-menu-item
              (click)="fixPermissions()">
              <mat-icon class="size-12">lock_open</mat-icon>
              <span class="buttonLabel">Fix Permissions</span>
            </button>
          }
          @if (order.updateAllowed) {
            <button class="menuButton" mat-menu-item (click)="updateEntityComplexity()">
              <mat-icon class="size-12">refresh</mat-icon>
              <span class="buttonLabel">Refresh Complexity</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECQEWLAdmin')) {
            <button class="menuButton" mat-menu-item
              (click)="openQewlDialog()">
              <mat-icon class="size-12">layers</mat-icon>
              <span class="buttonLabel">QEWL</span>
            </button>
          }
          @if (showUnrestrictedEditOption()) {
            <button class="menuButton" mat-menu-item (click)="showUnrestrictedChangesDialog()">
              <mat-icon class="size-12">edit</mat-icon>
              <span class="buttonLabel">Update Approved Order</span>
            </button>
          }
        </mat-menu>
        @if (order.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="sfrMenu">
            <span>
              <span class="buttonLabel">SFR Actions</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #sfrMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="sfrManagement()">
            <mat-icon class="size-12">local_grocery_store</mat-icon>
            <span class="buttonLabel">SFR Management</span>
          </button>
          @if (canSubmitSfrs()) {
            <button class="menuButton" mat-menu-item (click)="submitSfr()">
              <mat-icon class="size-12">event_available</mat-icon>
              <span class="buttonLabel">Submit SFR</span>
            </button>
          }
          @if (canCancelSfrs()) {
            <button class="menuButton" mat-menu-item (click)="cancelSfr()">
              <mat-icon class="size-12">not_interested</mat-icon>
              <span class="buttonLabel">Cancel Review</span>
            </button>
          }
        </mat-menu>
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="viewDocuments()">
          <span>
            <mat-icon class="size-16">content_copy</mat-icon>
            <span class="buttonLabel">Docs</span>
          </span>
        </button>
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="viewMenu">
          <span>
            <span class="buttonLabel">View</span>
            <mat-icon class="size-16">arrow_drop_down</mat-icon>
          </span>
        </button>
        <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
          @if (order.associatedQuoteId && order.associatedQuoteId.length > 0) {
            <button class="menuButton" mat-menu-item
              (click)="viewQuote()">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Quote</span>
            </button>
          }
          @if (order.associatedOrderId && order.associatedOrderId.length > 0) {
            <button class="menuButton" mat-menu-item
              (click)="viewBlanket()">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Order</span>
            </button>
          }
          @if (associatedOrders() && associatedOrders().length > 0) {
            <button class="menuButton" mat-menu-item
              (click)="viewReleaseSummary()">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Release Summary</span>
            </button>
          }
          <button class="menuButton" mat-menu-item (click)="showEntityHistoryDialog()">
            <mat-icon class="size-12">history</mat-icon>
            <span class="buttonLabel">History</span>
          </button>
          @if (isBlanket()) {
            <a class="menuLink" mat-menu-item
              [routerLink]="['/sabrSummary/' + order.projectNumber, order.id.entityId, order.customerId]" target="_blank">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Summary</span>
            </a>
          }
          @if (isBlanket()) {
            <button class="menuButton" mat-menu-item (click)="viewEstimatedReleaseSchedule('')">
              <mat-icon class="size-12">date_range</mat-icon>
              <span class="buttonLabel">Estimated Release Schedule</span>
            </button>
          }
          @if (!isBlanket()) {
            <button class="menuButton" mat-menu-item (click)="viewProcessingStatus()">
              <mat-icon class="size-12">date_range</mat-icon>
              <span class="buttonLabel">Processing Status</span>
            </button>
          }
          @if (showSchedulingDataButton()) {
            <button class="menuButton" mat-menu-item (click)="viewSchedulingData()">
              <mat-icon class="size-12">calendar_month</mat-icon>
              <span class="buttonLabel">Scheduling Data</span>
            </button>
          }
        </mat-menu>
        <mat-menu>
          @for (order of associatedOrders(); track order) {
            <button class="menuButton" mat-menu-item (click)="viewOrder(order)">
              <span class="buttonLabel">{{ order.entityId }};{{ order.entityRevision }}</span>
            </button>
          }
        </mat-menu>
        @if (order.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy() || !orderForm.valid" (click)="save()">
            <span>
              <mat-icon class="size-16">save</mat-icon>
              <span class="buttonLabel">Save</span>
            </span>
          </button>
        }
        @if (isOrderReviewable()) {
          <button class="toolbarButton orderReviewButton" matButton="text" [disabled]="isBusy() || !canSubmitForReview()" (click)="submitForReview()">
            <span>
              <mat-icon class="size-16">done</mat-icon>
              <span class="buttonLabel">Submit For Review</span>
            </span>
          </button>
        }
        @if (!canSubmitForReview()) {
          <button class="toolbarButton iconButton" matButton="text" [disabled]="isBusy()" [matTooltip]="getSubmitForReviewTooltip()">
            <mat-icon class="size-16">info</mat-icon>
          </button>
        }
      </span>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  @if (saveMessages() && saveMessages().length > 0) {
    <div class="saveMessage">
      @for (message of saveMessages(); track message) {
        <div>
          {{ message }}
        </div>
      }
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <span class="busyLabel">Please Wait...</span>
      </div>
    </div>
  }
  @if (order(); as order) {
    <div class="orderDetail">
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Order Information</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>OrderID:</span></td>
                <td class="dataColumn"><span>{{ order.id.entityId }};{{ order.id.entityRevision }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>IEC Project #:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCredAnalyst')) {
                    <input id="projectNumberInput" name="projectNumberInput"
                      class="standardTextBox inputField"
                      maxlength="8" [(ngModel)]="order.projectNumber"/>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCredAnalyst')) {
                    <span>{{ order.projectNumber }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>IEC Release #:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCredAnalyst')) {
                    <input id="releaseNumberInput" name="releaseNumberInput"
                      class="standardTextBox inputField"
                      maxlength="6" [(ngModel)]="order.releaseNumber"/>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCredAnalyst')) {
                    <span>{{ order.releaseNumber }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><label for="projectNameInput">Project Name:</label></td>
                <td class="dataColumn">
                  <input id="projectNameInput" name="projectNameInput" class="inputField standardTextBox" maxlength="30"
                    [ngClass]="{'inputError': projectNameInput.invalid}" required [(ngModel)]="order.projectName"
                    #projectNameInput="ngModel"/>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><label for="customerSelection">Customer:</label></td>
                <td class="dataColumn">
                  <select id="customerSelection" name="customerSelection" class="inputField"
                    [(ngModel)]="order.customerId">
                    @for (customer of customers(); track customer) {
                      <option [value]="customer.code">{{ customer.description }}</option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep Office:</span></td>
                <td class="dataColumn">
                  <span>{{ sellingOrgDescription() }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Release Type:</span></td>
                <td class="dataColumn">
                  <span>{{ getReleaseType() }}</span>
                </td>
              </tr>
              @if (userHasRole('IECCustomerService') || userHasRole('IECIT') || userHasRole('IECCredAnalyst') || userHasRole('IECApplicationEngineer') || userHasRole('IECRSM') ) {
                <tr
                  >
                  <td colspan="2">
                    <textarea name="internalNotesInput" rows="3" class="noresize fullWidth"
                    [(ngModel)]="order.internalNotes" placeholder="Internal Notes"></textarea>
                  </td>
                </tr>
              }
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Processing and Contacts</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Est Ship Date:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                    <div>
                      <input [matDatepicker]="shipDatePicker" name="shipDateInput"
                        [value]="formatDisplayDate(order.estimatedScheduleDate)" (dateChange)="setShipDate($event.value)"/>
                      <mat-datepicker-toggle [for]="shipDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="shipDatePicker" #shipDatePicker></mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                    <span>{{
                      order.estimatedScheduleDate
                      | date:'MM/dd/yyyy':'UTC'
                    }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>FOB:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                    <div
                      [ngClass]="{'selectionError': fobCodeInput.invalid}">
                      <select name="fobCodeInput" class="inputField" required [(ngModel)]="order.fobCode"
                        #fobCodeInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (fob of fobs(); track fob) {
                          <option [value]="fob.code">{{ fob.description }}</option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                    <span>{{ order.fobCode }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Order Info:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                    <div>
                      <input name="orderInfoInput" class="inputField standardTextBox" maxlength="10"
                        [(ngModel)]="order.orderInfo" />
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                    <div>
                      <span>{{ order.orderInfo }}</span>
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Payment Terms:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                    <div
                      [ngClass]="{'selectionError': paymentTermsInput.invalid}">
                      <select name="paymentTermsInput" class="inputField" required [(ngModel)]="order.paymentTermsCode"
                        #paymentTermsInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (paymentTerm of paymentTerms(); track paymentTerm) {
                          <option [value]="paymentTerm.code">
                            {{ paymentTerm.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                    <span>{{ order.paymentTermsCode }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned">
                  <span class="repSelection" (click)="showSalesRep()">
                    Sales Rep:
                  </span>
                </td>
                <td class="dataColumn">
                  <div [ngClass]="{'selectionError': salesRepIdInput.invalid}">
                    <select id="salesRepIdInput" name="salesRepIdInput" class="inputField" required
                      [(ngModel)]="order.salesRepId" #salesRepIdInput="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (salesRep of salesReps(); track salesRep) {
                        <option [value]="salesRep.code">{{ salesRep.description }}</option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              @if (order.totalQuoteAmount > 50000) {
                <tr>
                  <td class="rightAligned labelColumn"><label for="outsideSalesRepIdInput">Outside Sales
                  Rep:</label></td>
                  <td class="dataColumn">
                    <div [ngClass]="{'selectionError': outsideSalesRepIdInput.invalid}">
                      <select id="outsideSalesRepIdInput" name="outsideSalesRepIdInput" class="inputField"
                        [required]="order.totalQuoteAmount > 50000" [(ngModel)]="order.outsideSalesRepId"
                        #outsideSalesRepIdInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (salesRep of outsideSalesReps(); track salesRep) {
                          <option [value]="salesRep.code">
                            {{ salesRep.description }}
                          </option>
                        }
                      </select>
                    </div>
                  </td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn">
                  <span>SFR Price Date:</span>
                </td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT')) {
                    <div>
                      <input [matDatepicker]="sfrPriceDatePicker" name="sfrPriceDateInput"
                        [value]="formatDisplayDate(order.sfrPriceBasisDate)" (dateChange)="setSfrPriceDate($event.value)"/>
                      <mat-datepicker-toggle [for]="sfrPriceDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="sfrPriceDatePicker" #sfrPriceDatePicker>
                      </mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole('IECIT')) {
                    <span>{{ order.sfrPriceBasisDate | date:'MM/dd/yyyy':'UTC' }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned">
                  <span class="repSelection" (click)="showIecContact()">
                    IEC Contact:
                  </span>
                </td>
                <td class="dataColumn">
                  @if (userHasRole('IECCustomerService') || userHasRole('IECIT') || userHasRole('IECCredAnalyst') || userHasRole('IECApplicationEngineer') || userHasRole('IECRSM')) {
                    <div
                      [ngClass]="{'selectionError': iecContactIdInput.invalid}">
                      <select name="iecContactIdInput" class="inputField" required [(ngModel)]="order.iecContactId"
                        #iecContactIdInput="ngModel">
                        <option value="null" disabled>Please Select</option>
                        @for (iecContact of iecContacts(); track iecContact) {
                          <option [value]="iecContact.code">{{ iecContact.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole('IECCustomerService') && !userHasRole('IECIT') && !userHasRole('IECCredAnalyst') && !userHasRole('IECApplicationEngineer') && !userHasRole('IECRSM')) {
                    <span
                    >{{ order.iecContactDescription }}</span>
                  }
                </td>
              </tr>
              @if (order.skyportServicePresent) {
                <tr>
                  <td [ngClass]="{'skyportError': skyportContactMissing()}" class="rightAligned">
                    <span class="repSelection" (click)="selectSkyportContact()">
                      Skyport Contact
                    </span>
                  </td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn"><span>Last Process Date:</span></td>
                <td class="dataColumn"><span>{{ order.lastProcessDate | date:'MM/dd/yyyy':'UTC' }}</span></td>
              </tr>
              <tr>
                <td colspan="2"><span>Created: {{ createdBy() }} -
                {{ order.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span></td>
              </tr>
              <tr>
                <td colspan="2"><span>Updated: {{ updatedBy() }} -
                {{ order.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span></td>
              </tr>
              @if (hasMissingRiserData()) {
                <tr>
                  <td colspan="2">
                    <div class="riser-error">
                      This order has missing or invalid riser data.&nbsp;&nbsp;Please upload a valid riser chart
                    </div>
                  </td>
                </tr>
              }
            </table>
          </div>
        </div>
      </div>
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Pricing Controls</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td>
                  @if (order.leadTimeCode === 'WAR') {
                    <span class="warrantyTextSelection" (click)="showWarrantyText()">
                      Warranty Text
                    </span>
                  }
                </td>
                <td class="rightAligned labelColumn"><span>Lead Time:</span></td>
                <td class="dataColumn">
                  @if (order.leadTimeCode !== 'WAR' && order.leadTimeCode !== 'SLC') {
                    <div>
                      <select name="leadTimeCodeInput" class="inputField" [(ngModel)]="order.leadTimeCode"
                        (change)="refreshIecContact()">
                        @for ( leadTime of leadTimes(); track  leadTime) {
                          <option [value]="leadTime.code">
                            {{ leadTime.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (order.leadTimeCode === 'WAR') {
                    <span>Warranty</span>
                  }
                  @if (order.leadTimeCode === 'SLC') {
                    <span>Sales Concession</span>
                  }
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>Sales Channel:</span></td>
                <td class="dataColumn">
                  <select name="salesChannelCodeInput" class="inputField" [(ngModel)]="order.salesChannelCode">
                    @for (salesChannel of salesChannels(); track salesChannel) {
                      <option [value]="salesChannel.code">
                        {{ salesChannel.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              @if (showExpediteParts()) {
                <tr>
                  <td></td>
                  <td class="rightAligned labelColumn"></td>
                  <td class="dataColumn">
                    <input name="expeditePartsInput" id="expeditePartsInput" class="checkboxInput" type="checkbox"
                      [(ngModel)]="order.expedite"/>
                    <label for="expeditePartsInput">Expedite Parts</label>
                  </td>
                </tr>
              }
              @if (order.appEngineerSnBypass) {
                <tr>
                  <td></td>
                  <td class="rightAligned labelColumn"></td>
                  <td class="dataColumn">
                    <input name="serialNumberBypassInput" id="serialNumberBypassInput" class="checkboxInput"
                      type="checkbox" [checked]="true" disabled
                      title="This order was released with Serial Number Bypass approved"/>
                    <label for="serialNumberBypassInput">Serial Number Bypass</label>
                  </td>
                </tr>
              }
              @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                <tr>
                  <td></td>
                  <td class="rightAligned labelColumn"><span>Use Type:</span></td>
                  <td class="dataColumn">
                    <select name="useTypeCodeInput" class="inputField" [(ngModel)]="order.useTypeCode">
                      <option value="null" disabled>Please Select</option>
                      @for (useType of useTypes(); track useType) {
                        <option [value]="useType.code">{{ useType.description }}</option>
                      }
                    </select>
                  </td>
                </tr>
              }
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>Price Basis Date:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT')) {
                    <div>
                      <input [matDatepicker]="priceBasisDatePicker" name="priceBasisDateInput"
                        [value]="formatDisplayDate(order.priceBasisDate)" (dateChange)="setPriceBasisDate($event.value)"/>
                      <mat-datepicker-toggle [for]="priceBasisDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="priceBasisDatePicker" #priceBasisDatePicker>
                      </mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole('IECIT')) {
                    <span>{{ order.priceBasisDate | date:'MM/dd/yyyy':'UTC' }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>S&amp;H Charge Type:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService') || userHasRole('IECCredAnalyst')) {
                    <div>
                      <select name="shipChargeTypeInput" class="inputField" [(ngModel)]="order.shipAndHandChargeType">
                        <option value="null" disabled>Please Select</option>
                        @for (sAndHChargeType of sAndHChargeTypes(); track sAndHChargeType) {
                          <option [value]="sAndHChargeType.code">
                            {{ sAndHChargeType.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService') && !userHasRole('IECCredAnalyst')) {
                    <span
                    >{{ shippingHandlingDescription() }}</span>
                  }
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Shipping Information</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Ship To:</span></td>
                <td class="dataColumn">
                  <span class="addressSelection" (click)="selectAddress()">
                    {{ order.overrideShipToAddressLine1 || 'Select' }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Ship Via:</span></td>
                <td class="dataColumn">
                  <select name="shipViaCodeInput" class="inputField" [(ngModel)]="order.shipViaCode">
                    <option value="null" disabled>Please Select</option>
                    @for (shipVia of shipVias(); track shipVia) {
                      <option [value]="shipVia.code">{{ shipVia.description }}</option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Requested Ship Date:</span></td>
                <td class="dataColumn">
                  <input [matDatepicker]="requestedShipDatePicker" name="requestedShipDateInput"
                    [value]="formatDisplayDate(order.requestedShipDate)"
                    (dateChange)="setRequestedShipDate($event.value)"/>
                  <mat-datepicker-toggle [for]="requestedShipDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker id="requestedShipDatePicker" #requestedShipDatePicker>
                  </mat-datepicker>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"></td>
                <td class="dataColumn">
                  <input name="acceptEarlyInput" id="acceptEarlyInput" class="checkboxInput" type="checkbox"
                    [(ngModel)]="order.acceptEarlyDelivery"/>
                  <label for="acceptEarlyInput">Accept Early Delivery</label>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Advance Notice Hours:</span></td>
                <td class="dataColumn">
                  <input name="advanceNoticeHoursInput" class="inputField standardTextBox" maxlength="28"
                    [(ngModel)]="order.advanceNoticeHours" />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep PO#:</span></td>
                <td class="dataColumn">
                  <input name="repPoInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="order.repPo" />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep Ref#:</span></td>
                <td class="dataColumn">
                  <input name="repRefInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="order.repRef" />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Primary Contact:</span></td>
                <td class="dataColumn">
                  <span [hidden]="order.deliveryContactName || order.deliveryPhone" class="addressSelection"
                    (click)="enterContact(true)">
                    Enter Contact
                  </span>
                  <span [hidden]="!(order.deliveryContactName || order.deliveryPhone)" class="addressSelection"
                    (click)="enterContact(true)">
                    {{ order.deliveryContactName + "; " + order.deliveryPhone }}
                  </span>
                </td>
              </tr>
              <tr
                [hidden]="!((order.deliveryContactName || order.deliveryPhone) && (order.deliveryContactName2 || order.deliveryPhone2))">
                <td class="rightAligned labelColumn"><span>Secondary Contact:</span></td>
                <td class="dataColumn">
                  <span [hidden]="order.deliveryContactName2 || order.deliveryPhone2" class="addressSelection"
                    (click)="enterContact(false)">
                    Enter Contact
                  </span>
                  <span [hidden]="!(order.deliveryContactName2 && order.deliveryPhone2)" class="addressSelection"
                    (click)="enterContact(false)">
                    {{ order.deliveryContactName2 + "; " + order.deliveryPhone2 }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Delivery Country:</span></td>
                <td class="dataColumn">
                  <select name="deliveryCountryInput" class="inputField" [(ngModel)]="order.deliveryCountryCode">
                    <option value="null" disabled>Please Select</option>
                    @for (country of deliveryCountries(); track country) {
                      <option [value]="country.code">{{ country.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Mark Cartons:</span></td>
                <td class="dataColumn">
                  <input name="markCartonsInput" class="inputField standardTextBox" maxlength="30"
                    [(ngModel)]="order.markCartons" />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <textarea name="externalNotesInput" rows="2" class="noresize fullWidth"
                  [(ngModel)]="order.externalNotes" placeholder="External Notes"></textarea>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Marketing</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Market Segment:</span></td>
                <td class="dataColumn">
                  <div>
                    <select name="marketSegmentInput" class="marketingInput" [(ngModel)]="order.marketSegmentCode">
                      @for (segment of marketSegments(); track segment) {
                        <option [value]="segment.code">{{ segment.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Project Type:</span></td>
                <td class="dataColumn">
                  <div>
                    <select name="projectTypeInput" class="marketingInput" [(ngModel)]="order.projectTypeCode">
                      @for (projectType of projectTypes(); track projectType) {
                        <option [value]="projectType.code">
                          {{ projectType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Spec Type:</span></td>
                <td class="dataColumn">
                  <div>
                    <select name="specTypeInput" class="marketingInput" [(ngModel)]="order.specTypeCode">
                      @for (specType of specTypes(); track specType) {
                        <option [value]="specType.code">{{ specType.description }}</option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Order Totals</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Total List:</span></td>
                <td class="dataColumn"><span>{{ order.totalList | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Net Amount:</span></td>
                <td class="dataColumn"><span>{{ order.netAmount | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Special Charges:</span></td>
                <td class="dataColumn"><span>{{ (order.specialCharges - order.shippingHandlingChargeAmount - order.partShippingHandlingChargeAmount) | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Shipping and Handling:</span></td>
                <td class="dataColumn"><span>{{ order.shippingHandlingChargeAmount | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><label>Part Shipping and Handling:</label></td>
                <td class="dataColumn"><label>{{ order.partShippingHandlingChargeAmount | currency:'USD' }}</label></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Total Order Amount:</span></td>
                <td class="dataColumn"><span>{{ order.totalQuoteAmount | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Multiplier:</span></td>
                <td class="dataColumn"><span>{{ order.multiplier | number:'1.4-7' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Unit Quantity:</span></td>
                <td class="dataColumn"><span>{{ order.unitQuantity }}</span></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Order Status</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Milestone:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                    <div>
                      <select name="milestoneInput" class="inputField" [(ngModel)]="order.milestone">
                        @for (milestone of milestones(); track milestone) {
                          <option [value]="milestone.code">{{ milestone.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                    <span
                    >{{ order.milestoneDescription }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Review Status:</span></td>
                <td class="dataColumn"><span>{{ order.reviewStatus }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Approval Status:</span></td>
                <td class="dataColumn"><span>{{ order.approvalStatus }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Order Status:</span></td>
                <td class="dataColumn"><span>{{ order.statusDescription }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Tax Status:</span></td>
                <td class="dataColumn"><span>{{ order.taxStatus }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn">
                  <label for="frozenInput">Frozen:</label>
                </td>
                <td class="dataColumn">
                  @if (userHasRole('IECCustomerService') || userHasRole('IECIT')) {
                    <input name="frozenInput"
                      id="frozenInput" class="checkboxInput" type="checkbox" [(ngModel)]="order.frozen"/>
                  }
                  @if (!userHasRole('IECCustomerService') && !userHasRole('IECIT')) {
                    <span>{{
                      order.frozen ? 'Yes' :
                      'No'
                    }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>ERP Status:</span></td>
                <td class="dataColumn">
                  @if (userHasRole('IECCustomerService') || userHasRole('IECIT')) {
                    <input name="erpStatusInput"
                      id="erpStatusInput" class="standardTextBox" maxlength="10" [(ngModel)]="order.erpStatus"/>
                  }
                  @if (!userHasRole('IECCustomerService') && !userHasRole('IECIT')) {
                    <span>{{ order.erpStatus }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>SFR Status:</span></td>
                <td class="dataColumn"><span>{{ order.sfrStatus }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>FPA Status:</span></td>
                <td class="dataColumn"><span>{{ order.fpaStatus }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Credit Exception:</span></td>
                <td class="dataColumn"><span>{{ creditExceptionDescription() }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Ship Date:</span></td>
                <td class="dataColumn"><span>{{ order.lastConfirmedShipDate | date:'MM/dd/yyyy':'UTC' }} via
                {{ order.shipVia }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Tracking Number:</span></td>
                <td class="dataColumn"><span>{{ order.trackingNumber }}</span></td>
              </tr>
              @if (showComplexityCategory()) {
                <tr>
                  <td class="rightAligned labelColumn"><span>Estimated Eng. Effort:</span></td>
                  <td class="dataColumn">
                    <span class="dataLabel">{{ getComplexityCategory() }}</span>
                    <mat-icon color="primary" (click)="showComplexityInformationDialog()" class="size-16 infoIcon">info
                    </mat-icon>
                  </td>
                </tr>
              }
              @if (showComplexityCategory()) {
                <tr>
                  <td class="rightAligned labelColumn">Estimated Lead Time:</td>
                  <td class="dataColumn">{{ getComplexityLeadTime() }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
      </div>
      @if (order) {
        <div class="lineToolbar">
          <span class="linesLabel">
            <h3>Order Lines</h3>
          </span>
          <span class="spacer">
          </span>
          <span>
            <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="generateConsolidatedLines()">
              <span>
                <mat-icon class="size-16">reorder</mat-icon>
                @if (!isConsolidatedView) {
                  <span class="buttonLabel">Consolidate Lines</span>
                }
                @if (isConsolidatedView) {
                  <span class="buttonLabel">Expand Lines</span>
                }
              </span>
            </button>
            @if (showRiserChartButton()) {
              <button class="toolbarButton" matButton="text" [disabled]="order.frozen"
                (click)="openRiserChartDialog()">
                <span>
                  <mat-icon class="size-16">table_chart</mat-icon>
                  <span class="buttonLabel">Riser Chart</span>
                </span>
              </button>
            }
            @if (order.updateAllowed) {
              <button class="toolbarButton" matButton="text" [ngClass]="{'skyportTaggingError': taggingRoomMissing()}"
                [disabled]="isBusy() || order.frozen" (click)="openTaggingDialog()">
                <span>
                  <mat-icon class="size-16">local_offer</mat-icon>
                  <span class="buttonLabel">Tagging</span>
                </span>
              </button>
            }
            @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
              <button class="toolbarButton" matButton="text" [disabled]="isBusy()"
                (click)="openLeadTimeDialog()">
                <span>
                  <mat-icon class="size-16">today</mat-icon>
                  <span class="buttonLabel">Lead Times</span>
                </span>
              </button>
            }
            <button class="toolbarButton" matButton="text" [disabled]="isBusy() || getSelectedLineCount() !== 1 || isConsolidatedView"
              (click)="showLineSummary()">
              <span>
                <mat-icon class="size-16">visibility</mat-icon>
                <span class="buttonLabel">Summary</span>
              </span>
            </button>
            @if (order.updateAllowed) {
              <button class="toolbarButton" matButton="text"
                [disabled]="isBusy() || getSelectedLineCount() === 0 || isSureFlowUnitSelected() || order.frozen"
                (click)="cancelSelectedLines()">
                <span>
                  <mat-icon class="size-16">delete</mat-icon>
                  <span class="buttonLabel">Cancel</span>
                </span>
              </button>
            }
            @if (order.updateAllowed) {
              <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="openSureFlowLoopSimulator()">
                <span>
                  <mat-icon class="size-16">sim_card</mat-icon>
                  <span class="buttonLabel">SureFlow® Loops</span>
                </span>
              </button>
            }
            @if (order.updateAllowed) {
              <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="openConfigurator()">
                <span>
                  <mat-icon class="size-16">build</mat-icon>
                  <span class="buttonLabel">Configurator</span>
                </span>
              </button>
            }
            @if (canAddLines()) {
              <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="addParts()">
                <span>
                  <mat-icon class="size-16">add</mat-icon>
                  <span class="buttonLabel">Parts</span>
                </span>
              </button>
            }
            <button class="toolbarButton" matButton="text" [disabled]="!canCopyLines()" (click)="copyLines()">
              <span>
                <mat-icon class="size-16">filter_none</mat-icon>
                <span class="buttonLabel">Copy To</span>
              </span>
            </button>
            @if (canAddLines()) {
              <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="addRisers()">
                <span>
                  <mat-icon class="size-16">add</mat-icon>
                  <span class="buttonLabel">Risers</span>
                </span>
              </button>
            }
          </span>
        </div>
      }
      @if (order) {
        <div>
          <table class="reportTable fullTableWidth">
            <thead>
              <tr>
                <td class="tableCell headerCell centeredCell">Line</td>
                <td class="tableCell headerCell centeredCell">Product</td>
                <td class="tableCell headerCell centeredCell">Description</td>
                <td class="tableCell headerCell centeredCell">Item Number</td>
                <td class="tableCell headerCell centeredCell">Quantity</td>
                <td class="tableCell headerCell centeredCell">Best Lead Time</td>
                <td class="tableCell headerCell centeredCell">Unit List</td>
                <td class="tableCell headerCell centeredCell">Multiplier</td>
                <td class="tableCell headerCell centeredCell">Final Unit Price</td>
                <td class="tableCell headerCell centeredCell">Final Ext Price</td>
                <td class="tableCell headerCell centeredCell">Customer Item #</td>
                <td class="tableCell headerCell centeredCell">Tags</td>
              </tr>
            </thead>
            @if (consolidatedLines && consolidatedLines.length > 0 && isConsolidatedView) {
              @for (line of consolidatedLines; track line) {
                <tr [class.selectedRow]="isLineSelected(line)"
                  [class.incompleteRow]="line.configured && !line.configurationComplete"
                  [class.serialNumberMissingRow]="line.serialNumberRequired && (line.quantity > 1 || !line.serialNumber)"
                  class="selectableRow"
                  >
                  <td class="tableCell"></td>
                  <td class="tableCell">{{ line.product }}</td>
                  <td class="tableCell">{{ line.description }}</td>
                  <td class="tableCell centeredCell"></td>
                  <td class="tableCell centeredCell">{{ line.quantity }}</td>
                  <td class="tableCell centeredCell"></td>
                  <td class="tableCell rightAligned">{{ line.unitList | currency:'USD' }}</td>
                  <td class="tableCell centeredCell">{{ line.multiplier | number:'1.4-7' }}</td>
                  <td class="tableCell rightAligned"></td>
                  <td class="tableCell rightAligned"></td>
                  <td class="tableCell">{{ line.customerItemNumber }}</td>
                  <td class="tableCell">
                  </td>
                </tr>
              }
            }
            @if (order.lines && order.lines.length > 0 && !isConsolidatedView) {
              @for (line of order.lines; track line) {
                <tr [class.selectedRow]="isLineSelected(line)"
                  [class.incompleteRow]="line.configured && !line.configurationComplete"
                  [class.serialNumberMissingRow]="line.serialNumberRequired && (line.quantity > 1 || !line.serialNumber)"
                  class="selectableRow"
                  (click)="selectLineRow($event, line)">
                  <td class="tableCell">{{ line.lineId }}</td>
                  <td class="tableCell">{{ line.product }}</td>
                  <td class="tableCell">{{ line.description }}</td>
                  <td class="tableCell centeredCell">{{ line.itemNumber }}</td>
                  <td class="tableCell centeredCell">{{ line.quantity }}</td>
                  <td class="tableCell centeredCell">{{ line.bestLeadTime }}</td>
                  <td class="tableCell rightAligned">{{ line.unitList | currency:'USD' }}</td>
                  <td class="tableCell centeredCell">{{ line.multiplier | number:'1.4-7' }}</td>
                  <td class="tableCell rightAligned">{{ line.finalUnitPrice | currency:'USD' }}</td>
                  <td class="tableCell rightAligned">{{ line.finalExtendedPrice | currency:'USD' }}</td>
                  <td class="tableCell">{{ line.customerItemNumber }}</td>
                  <td class="tableCell">
                    @if (line.tags && line.tags.length > 0) {
                      <span>{{
                        line.tags.substring(0, 20) + (line.tags.length > 20 ?
                        '...' : '')
                        }}
                      </span>
                    }
                  </td>
                </tr>
              }
            }
            @if (!order.lines || order.lines.length === 0) {
              <tr>
                <td colspan="11">No lines found</td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
  }
</form>
